import qs from "qs";
import {
  defaultOrganisationSearchQuery,
  OrganisationSearchQueryState,
} from "../context/OrganisationSearchQuery";

import { pick } from "lodash-es";

function alphabeticalSort(a: string, b: string): number {
  return a.localeCompare(b);
}

const qsOptions: qs.IStringifyOptions = {
  arrayFormat: "repeat",
  // sorts keys, not values
  sort: alphabeticalSort,
};

const KEYS: (keyof OrganisationSearchQueryState)[] = [
  "category",
  "keyword",
  "page",
  "where",
];

export const normalizeQuery = (
  searchQuery?: OrganisationSearchQueryState
): OrganisationSearchQueryState => {
  if (searchQuery === undefined) {
    return defaultOrganisationSearchQuery;
  }

  // remove all unused keys
  searchQuery = pick(searchQuery, KEYS);

  // normalize query with default from server
  // empty keyword on server is null
  if (searchQuery.keyword === "") {
    searchQuery.keyword = null;
  }

  // query.where make each word uppercase
  // and remove extraenous spaces
  if (searchQuery.where === "") {
    searchQuery.where = null;
  }

  // server page property default is null
  if (searchQuery.page === 1) {
    searchQuery.page = null;
  }

  // remove duplicate entries and
  // sort arrays from lowest to highest
  for (const key in searchQuery) {
    if (Array.isArray(searchQuery[key])) {
      searchQuery[key] = [...Array.from(new Set<number>(searchQuery[key]))];
      searchQuery[key] = searchQuery[key].sort((a, b) => a - b);
    }
  }

  return searchQuery;
};

export const organisationSearchQueryToString = (
  searchQuery?: OrganisationSearchQueryState
): string => {
  if (searchQuery === undefined) {
    return qs
      .stringify(defaultOrganisationSearchQuery, qsOptions)
      .toLocaleLowerCase();
  }

  return qs
    .stringify(
      { ...defaultOrganisationSearchQuery, ...normalizeQuery(searchQuery) },
      qsOptions
    )
    .toLocaleLowerCase();
};
